"use strict";

exports.__esModule = true;
exports["default"] = prompt;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _antd = require("antd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var PromptForm =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(PromptForm, _Component);

  function PromptForm() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PromptForm.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        form = _this$props.form,
        rules = _this$props.rules,
        placeholder = _this$props.placeholder;
    var getFieldDecorator = form.getFieldDecorator;
    return _react["default"].createElement(_antd.Form, null, _react["default"].createElement(_antd.Form.Item, null, getFieldDecorator('input', {
      rules: rules
    })(_react["default"].createElement(_antd.Input, {
      placeholder: placeholder
    }))));
  };

  return PromptForm;
}(_react.Component);

var EnhancedPromptForm = _antd.Form.create()(PromptForm);

var Prompt =
/*#__PURE__*/
function (_Component2) {
  _inheritsLoose(Prompt, _Component2);

  function Prompt() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component2.call.apply(_Component2, [this].concat(args)) || this;
    _this.state = {
      visible: false
    };

    _this.onOk = function () {
      _this.formRef.props.form.validateFields(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(err, values) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!err) {
                    _this.props.close(values.input);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    };

    return _this;
  }

  var _proto2 = Prompt.prototype;

  _proto2.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        modalProps = _this$props2.modalProps,
        rules = _this$props2.rules,
        placeholder = _this$props2.placeholder;
    return _react["default"].createElement(_antd.Modal, _extends({}, modalProps, {
      visible: this.props.visible,
      onOk: this.onOk,
      onCancel: function onCancel() {
        return _this2.props.close();
      },
      title: this.props.title,
      getContainer: false,
      afterClose: this.props.afterClose
    }), _react["default"].createElement(EnhancedPromptForm, {
      wrappedComponentRef: function wrappedComponentRef(ref) {
        return _this2.formRef = ref;
      },
      rules: rules,
      placeholder: placeholder
    }));
  };

  return Prompt;
}(_react.Component);

function prompt(config) {
  return new Promise(function (resolve, reject) {
    var div = document.createElement('div');
    document.body.appendChild(div); // eslint-disable-next-line no-use-before-define

    var currentConfig = _objectSpread({}, config, {
      close: close,
      visible: true
    });

    function destroy(value) {
      var unmountResult = _reactDom["default"].unmountComponentAtNode(div);

      if (unmountResult && div.parentNode) {
        div.parentNode.removeChild(div);
      }

      if (value !== undefined) {
        resolve(value);
      } else {
        reject(value);
      }
    }

    function render(props) {
      _reactDom["default"].render(_react["default"].createElement(Prompt, props), div);
    }

    function close(value) {
      currentConfig = _objectSpread({}, currentConfig, {
        visible: false,
        afterClose: destroy.bind(this, value)
      });
      render(currentConfig);
    }

    render(currentConfig);
  });
}